<template>
  <div class="col-sm-12 col-md">
    <abstract-profile-text-input
      :id="`input-billing_address_state`"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import AbstractProfileTextInput from "../core/AbstractProfileTextInput";
import BaseInputMixin from "@/mixins/profileInputMixin";

export default {
  name: "BillingState",
  components: {AbstractProfileTextInput},
  mixins: [BaseInputMixin('billing_address.state')],

  data() {
    return {
      name: 'billing_address.state',
      defaultLabel: this.$t("State")
    }
  }
}
</script>

<style scoped>

</style>
